import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS, FOR_INVESTORS_SUB_SECTIONS } from 'constants/businessToolSections/forInvestors';

import useCheckSubSectionAccess from 'hooks/useCheckSubSectionAccess';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import { PersonnelProfiles } from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ManagementTeam/PersonnelProfiles';
import {
  MANAGEMENT_TEAM_NAMES,
  personnelProfilesValue,
  prefix,
} from 'components/BusinessToolForm/Sections/ManagementAndOrganization/ManagementTeam/utils/form';

import { concatWithDot } from 'helpers/string';

export const ManagementTeam: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = useCheckSubSectionAccess(
    FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION,
    FOR_INVESTORS_SUB_SECTIONS.FOR_INVESTORS_MANAGEMENT_AND_ORGANIZATION.MANAGEMENT_TEAM,
  );

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          locked={!canAccess}
          title={t('management.title')}
          badgeText={t('management.team.title')}
          section={FOR_INVESTORS_SECTIONS.MANAGEMENT_AND_ORGANIZATION}
        />
      </FormSectionCard>
      {/* 7.1.1 */}
      <FormSectionCard
        disabled={!canAccess}
        title={t('management.team.history')}
        aiFieldName={concatWithDot(prefix, MANAGEMENT_TEAM_NAMES.HISTORY)}
      >
        <TextInputControl
          multiline
          control={control}
          id={concatWithDot(prefix, MANAGEMENT_TEAM_NAMES.HISTORY)}
          name={concatWithDot(prefix, MANAGEMENT_TEAM_NAMES.HISTORY)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      {/* 7.1.4 */}
      <FormSectionCard disabled={!canAccess} title={t('management.team.keyPersonnel')} collapsible>
        <FieldArrayComponent
          name={concatWithDot(prefix, MANAGEMENT_TEAM_NAMES.PERSONNEL_PROFILES)}
          initialItem={personnelProfilesValue}
          buttonText={t('management.team.keyPersonnelButtonText')}
          disabled={!canAccess}
        >
          {(namePrefix) => <PersonnelProfiles name={namePrefix} disabled={!canAccess} />}
        </FieldArrayComponent>
      </FormSectionCard>
    </>
  );
};
